import { Typography } from "@material-ui/core";
import { useNotify, useRedirect } from "ra-core";
import {
  Edit,
  SimpleForm,
  ReferenceArrayInput,
  ImageInput,
  ImageField,
} from "ra-ui-materialui";
import SelectInputRA from "../components/SelectInputRA";

import TextInputRA from "../components/TextInputRA";
const transform = (data) => ({
  ...data,
  level: Number(data.level),
  conditions: [
    { value: data.tier_condition_value, condition_id: data.tier_condition_id },
  ],
  privileges: [
    {
      condition: {
        value: data.condition_value,
        condition_id: data.condition_id,
      },
      item: { value: data.coupon_value, coupon_id: data.coupon_id },
    },
  ],
});
const CategoryEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const onSuccess = () => {
    notify("Edit successfully"); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const onFailure = (error) => {
    console.error(error);
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };
  return (
    <Edit
      mutationMode="pessimistic"
      onSuccess={onSuccess}
      onFailure={onFailure}
      transform={transform}
      {...props}
    >
      <SimpleForm>
        <TextInputRA label="Tier name" source="name" />
        <TextInputRA label="Level" source="level" type="number" />
        <Typography variant="h4">Tier condition</Typography>
        <ReferenceArrayInput
          label="Condition"
          source="tier_condition_id"
          reference="conditions"
        >
          <SelectInputRA optionText="name" />
        </ReferenceArrayInput>
        <Typography style={{ fontSize: 12 }}>
          *LTV >=[?] is recommeded{" "}
        </Typography>
        <TextInputRA
          label="value"
          source="tier_condition_value"
          type="number"
        />
        <Typography variant="h4">Privileges</Typography>
        <ReferenceArrayInput
          label="Condition"
          source="condition_id"
          reference="conditions"
        >
          <SelectInputRA optionText="name" />
        </ReferenceArrayInput>
        <TextInputRA
          label="Condition value"
          source="condition_value"
          type="number"
        />
        <ReferenceArrayInput
          label="Coupon"
          source="coupon_id"
          reference="coupons"
        >
          <SelectInputRA optionText="name" />
        </ReferenceArrayInput>
        <TextInputRA label="Coupon value" source="coupon_value" type="number" />
        <ImageInput label="Icon" accept="image/*" source="image">
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Edit>
  );
};

export default CategoryEdit;
